import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class FuelFilledStore {
  fuelFilled = [];
  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      fuelFilled: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getFuelFilledData: action,
      exportExcel: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;
    console.log("fuel filled ");
    const params = { companyId: companyId, offset: 0, limit: 15, page: 1 };

    // var postData = { companyId: companyId, offset: 0, limit: 15, page: 1 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=getFuelfilled", "postData=" + base64Input);
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("FuelDetails/getFuelFilledDetails", { params: params });
    console.log("company Data", response?.data?.data);
    this.fuelFilled = response?.data?.data;
    this.loading = false;
  }
  async addData(postData) {
    // var postData = values;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=fuelFilled", "postData=" + base64Input);
    // console.log(response);
    // return response.data;

    var fuelData = { postData };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("FuelDetails/saveFuelFilledDetailsData", fuelData);
    return response.data;
  }

  async deleteRecord({ fuel_Id }) {
    // var postData = {"tokenId":"","FuelFilled":{"fuel_Id":fuel_Id}}
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi.getClient().post("index.php?c=fuel&a=deleteFuel", "postData=" + base64Input);
    // return response

    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("FuelDetails/deleteFuelFilledDetails", {
        params: {
          fuel_Id: fuel_Id,
        },
      });
    return response;
  }
  async getFuelFilledData({ fuel_Id, offset, limit }) {
    // var postData = { fuel_Id: fuel_Id, offset: 0, limit: 1 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=getFuelfilled", "postData=" + base64Input);
    const params = { fuel_Id, limit: 1, offset: 0 };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("FuelDetails/getFuelFilledDetails", {
        params: params,
      });
    return response.data?.data[0];
  }

  async exportExcel(postData) {
    // window.location.href =
    //   config.baseURL +
    //   "index.php?&c=fuel&a=fuelfilledExportexcel&cid=" +
    //   getData.cid +
    //   "&colList=" +
    //   getData.colList;
    try {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("FuelDetails/exportFuelFilledDetailsExcel", postData, {
          responseType: "blob",
        });
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Fuel Filled Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default FuelFilledStore;
